<template>
  <router-view />
</template>

<script>
export default {
  name: 'Role'
}
</script>

<style scoped>

</style>
